import React from 'react';
import FortisButton from '../../Basic/FortisButton';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import LinkButton from '../../Basic/LinkButton';

class GasAccountLink extends React.Component {

  onOkClick() {
    window.location.href = 'https://www.fortisbc.com/Pages/Moving-New-accounts-stop-or-move-service.aspx?utm_source=OSA&utm_medium=Online%20form';
  }
  onCancelClick() {
    window.location.href = 'http://www.fortisbc.com';
  }

  render() {
    return (
      <div>
        <hr className="soften" />
        <div className="col-sm-12 offramp-page" >
          <br />
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                Learn about <a href="https://www.fortisbc.com/Pages/Moving-New-accounts-stop-or-move-service.aspx?utm_source=OSA&utm_medium=Online%20form">setting up a gas account</a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <ButtonToolbar  style={{display: "inline-flex"}}>
                  <LinkButton text="Cancel" onClick={() => this.onCancelClick} />
                  <FortisButton text="Ok" onClick={() => this.onOkClick} />
                </ButtonToolbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default GasAccountLink;